import { createContext, useContext, ReactNode } from 'react';
import { IWizardNavigation, IWizardData, IWizardStep } from './types';

interface IWizardContext<TData = any> {
  navigation: IWizardNavigation;
  data: IWizardData<TData>;
  isSubmitting: boolean;
  currentStep: IWizardStep<TData> | undefined;
}

const WizardContext = createContext<IWizardContext | null>(null);

export const useWizard = <TData = any,>(): IWizardContext<TData> => {
  const context = useContext(WizardContext);
  if (!context) {
    throw new Error('useWizard must be used within a MultistepWizard component');
  }
  return context as IWizardContext<TData>;
};

interface WizardProviderProps<TData = any> {
  children: ReactNode;
  value: IWizardContext<TData>;
}

export const WizardProvider = <TData,>({ children, value }: WizardProviderProps<TData>) => {
  return (
    <WizardContext.Provider value={value as IWizardContext}>{children}</WizardContext.Provider>
  );
};
